import { render, staticRenderFns } from "./paginationNextIcon.vue?vue&type=template&id=0ac40f46&"
import script from "./paginationNextIcon.vue?vue&type=script&lang=js&"
export * from "./paginationNextIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports